import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { cloneDeep, setObjectValue, unsub } from '@util/utils';
import { DataService } from '@data/data.service';
import {
  getRowStyle,
  OrdersGridComponent,
} from '../../grid/orders-grid/orders-grid.component';
import { ToolbarService } from '../../toolbar/toolbar.service';
import { findOrderStatusNameById } from '../../montage-orders/order-basic';
import {
  CONFIG_KEYS,
  isAdminType,
  StateService,
} from '@services/state.service';
import { GridColumnStyles, MyLog } from '@common/common';
import {
  statusColumn,
  teamColumn,
  trashOrderDateColumn,
  customerColumn,
  licensePlateColumn,
  deleteDateColumn,
  docIdColumnForTrash,
  orderDateColumnForTrash,
} from '../../montage-orders/order-columns';
import { Subscription } from 'rxjs';
import {
  OrderChangeEvent,
  OrderDialogService,
  ORDER_OPERATIONS,
} from '../../montage-orders/order-dialog.service';
import { toRequestDate } from '@util/date-utils';
import { EditCellRendererComponent, EditCellRendererEvent, EditCellRendererEventType } from '@grid-cell/edit-cell-renderer.component';
import { ColDef } from 'ag-grid-community';
import { OrderCellRendererComponent } from '@grid-cell/order-cell-renderer.component';
import { OrderCustomerRenderer } from '@common/order-customer-renderer';
import { DocnameCellRendererComponent } from '@grid-cell/docname-cell-renderer.component';
import { TrashGridType } from '../trash.constants';
//import { ClientSideRowModelModule } from "ag-grid-community/client-side-row-model";

//ModuleRegistry.registerModules([ClientSideRowModelModule]);

const mapping: any = {
  orders: 'Papierkorb für Aufträge',
  documents: 'Papierkorb für Dokumente',
};

const orderEditColumn: ColDef = {
  headerName: '',
  width: 80,
  minWidth: 70,
  editable: false,
  cellClass: 'tablan-edit-cell',
  cellRenderer: EditCellRendererComponent,
  cellRendererParams: {
    titleDelete: 'Auftrag löschen',
    titleRestore: 'Auftrag wiederherstellen',
    canDelete: true,
    restoreUrl: '/montage/trash/orders/'
  },
  pinned: 'right',
};

const orderNrColumnForDocumentsMontage = {
  field: 'order_id',
  headerName: 'Auftrag',
  cellClass: 'order-cell',
  cellRenderer: OrderCellRendererComponent,
  width: 120,
};

const editColumnForDocs: ColDef = {
  headerName: '',
  width: 80,
  minWidth: 70,
  editable: false,
  cellClass: 'tablan-edit-cell',
  cellRenderer: EditCellRendererComponent,
  cellRendererParams: {
    canDelete: true,
    checkMissing: true,
    canRestore: true
  },
  pinned: 'right',
};

const customerColumnForDocs = {
  field: 'customer',
  headerName: 'Kunde',
  cellRenderer: OrderCustomerRenderer,
  flex: 1,
  minWidth: 200,
  cellRendererParams: {
    onlyName: true
  }
};

const filenameColumnForDocumentsTrash = {
  field: 'name',
  headerName: 'Dateiname',
  width: 360,
  cellRenderer: DocnameCellRendererComponent,
  cellClass: GridColumnStyles.CELL_CLASS_STRING,
};

function unsetOnClick(options: any) {
  let cl = options.columnDefs.length;
  options.columnDefs[cl - 1].onClick = null;
}

@Component({
  selector: 'app-open-orders',
  templateUrl: './order-trash.component.html',
})
export class OrderTrashComponent implements OnInit, OnDestroy {
  public _grid!: OrdersGridComponent;

  startDate?: Date;

  endDate?: Date;

  rows: any[] = [];

  lastFilterValue = '';

  onFilterChange($event: any) {
    return;
  }

  filterValues: any;

  onFilterClickChange($event: any) {
    this.filterValues = $event;
    this.reloadData();
  }

  setGrid(grid: OrdersGridComponent) {
    this._grid = grid;
    this.updateGridOptions();
    this.updateGrid();
  }

  updateGrid() {
    this._grid && this._grid.setRowData(this.rows);
  }

  @ViewChild('grid', {
    read: OrdersGridComponent,
  })
  set grid(grid: OrdersGridComponent) {
    this.setGrid(grid);
  }

  isAdmin: isAdminType = true;

  stateSub?: Subscription;

  orderChangeSub?: Subscription;
  accessUrl = '';

  orderGridType = '';

  gridOptionsForOrders: any = {
    headerHeight: 40,
    defaultColDef: {
      headerClass: 'def-col',
      autoHeight: true,
      cellClass: GridColumnStyles.CELL_CLASS_STRING,
    },
    columnDefs: [
      docIdColumnForTrash,
      deleteDateColumn,
      statusColumn,
      teamColumn,
      trashOrderDateColumn,
      customerColumn,
      licensePlateColumn,
      orderEditColumn,
    ],
    enableCellTextSelection: true,
    alwaysShowHorizontalScroll: true,
    alwaysShowVerticalScroll: true,
    getRowStyle,
  };

  gridOptionsForDocuments: any = {
    headerHeight: 40,
    defaultColDef: {
      headerClass: 'def-col',
      autoHeight: true,
      cellClass: GridColumnStyles.CELL_CLASS_STRING,
    },
    columnDefs: [
      orderNrColumnForDocumentsMontage,
      orderDateColumnForTrash,
      docIdColumnForTrash,
      deleteDateColumn,
      customerColumnForDocs,
      filenameColumnForDocumentsTrash,
      editColumnForDocs,
    ],
    enableCellTextSelection: true,
    alwaysShowHorizontalScroll: true,
    alwaysShowVerticalScroll: true,
    getRowStyle,
  };

  updateGridOptions() {
    if (this._grid) {
      //console.log('updateGridOptions');
      let options = this.gridOptionsForOrders;

      if (TrashGridType.DOCUMENTS === this.orderGridType) {
        options = this.gridOptionsForDocuments;
      }
      this._grid.setGridOptions(options);
    }
  }

  setEditColumn() {
    if (TrashGridType.ORDERS === this.orderGridType) {
      const editCol: any = {
        headerName: '',
        width: 80,
        minWidth: 70,
        editable: false,
        cellClass: 'tablan-edit-cell',
        cellRenderer: EditCellRendererComponent,
        cellRendererParams: {
          titleDelete: 'Auftrag löschen',
          titleRestore: 'Auftrag wiederherstellen',
          canDelete: true,
          canRestore: true,
          onClick: (e: any) => {
            this.onEditClick(e);
          },
          restoreType: 'orders',
        },
        pinned: 'right',
      }
      const cl = this.gridOptionsForOrders.columnDefs.length;
      this.gridOptionsForOrders.columnDefs[cl - 1] = editCol;
    }

    if (TrashGridType.DOCUMENTS === this.orderGridType) {
      const editCol: ColDef = {
        headerName: '',
        width: 120,
        minWidth: 80,
        editable: false,
        cellClass: 'tablan-edit-cell',
        cellRenderer: EditCellRendererComponent,
        cellRendererParams: {
          canDelete: true,
          canDownload: true,
          checkMissing: true,
          canRestore: true,
          canEdit: false,
          titleDelete: 'Dokument löschen',
          titleRestore: 'Dokument wiederherstellen',
          onClick: (e: any) => {
            this.onEditClick(e);
          },
          restoreType: 'documents',
        },
        pinned: 'right',
      };
      const cl = this.gridOptionsForDocuments.columnDefs.length;
      this.gridOptionsForDocuments.columnDefs[cl - 1] = editCol;
    }
  }

  constructor(
    private currentRoute: ActivatedRoute,
    private dataService: DataService,
    private toolbarService: ToolbarService,
    private stateService: StateService,
    private orderDialogService: OrderDialogService,
  ) { }

  ngOnInit(): void {
    let title = 'Papierkorb';

    const urlParts: UrlSegment[] = this.currentRoute.snapshot.url;

    let trashType = (urlParts.length > 1) ? urlParts[1].path : '';

    this.orderGridType = trashType;

    if (trashType && mapping[trashType]) {
      title = mapping[trashType];
    }

    this.setEditColumn();

    this.toolbarService.setTitle(title);

    this.isAdmin = this.stateService.isAdmin();

    this.stateSub = this.stateService
      .adminChange()
      .subscribe((isAdmin: isAdminType) => {
        this.isAdmin = isAdmin;
        this.updateGridOptions();
      });

    this.orderChangeSub = this.orderDialogService
      .orderChanges()
      .subscribe((change: OrderChangeEvent) => {
        if (change.success && change.type === ORDER_OPERATIONS.DELETED
        ) {
          this.reloadData();
        }
        if (change.success && change.type === ORDER_OPERATIONS.DOCUMENT_DELETED) {
          this.reloadData(change.type, change.id);
        }
      });

    this.accessUrl = '/montage/trash/' + trashType;

    this.setDates();

    this.filterValues = {
      text: '',
      from: this.startDate,
      to: this.endDate,
    };

    this.loadData(this.accessUrl, false);
  }

  onEditClick(e: EditCellRendererEvent) {
    MyLog.log('TRASH:E:', e);
    if (!e || !e.data) {
      return;
    }

    const data = e.data;
    const id = data.id;
    if (!id) {
      return;
    }

    switch (e.type) {
      case EditCellRendererEventType.DELETE:
        if (TrashGridType.ORDERS === this.orderGridType) {
          const deleteCallback = (result: any) => {
            console.log('CB!:', result);
            if (result && result.success) {
              this.reloadData();
            }
          }
          this.orderDialogService.tryDeleteOrder(id, data, true, deleteCallback);
          return;
        }

        if (TrashGridType.DOCUMENTS === this.orderGridType &&
          data.order_id && data.id
        ) {
          this.orderDialogService.tryDeleteDocument(true,
            data.order_id,
            data.id,
            data.name
          );
          return;
        }
        break;
      case EditCellRendererEventType.RESTORE:
        const restoreCallback = (result: any) => {
          if (result && result.success) {
            this.reloadData();
          }
        };
        if (TrashGridType.ORDERS === this.orderGridType) {
          this.orderDialogService.tryRestoreOrder(id, restoreCallback);
          return;
        }

        if (TrashGridType.DOCUMENTS === this.orderGridType &&
          data.order_id && data.id
        ) {
          this.orderDialogService.tryRestoreDocument(
            data.order_id,
            data.id,
            (result: any) => {
              if (result && result.success) {
                this.reloadData(ORDER_OPERATIONS.DOCUMENT_RESTORED, result.doc_id);
              }
            }
          );

          return;
        }
        break;
      default:
        MyLog.error('TRASH:UNKNOWN:', e);
    }
  }

  setDates() {
    const startDate = this.stateService.getConfigurationFor(
      CONFIG_KEYS.ORDER_START_DATE
    );

    this.endDate = this.stateService.getConfigurationFor(
      CONFIG_KEYS.ORDER_END_DATE,
      startDate
    );

    this.startDate = startDate;
  }

  reloadData(reason?: string, id?: any) {
    const isDocReason = (ORDER_OPERATIONS.DOCUMENT_DELETED === reason ||
      ORDER_OPERATIONS.DOCUMENT_RESTORED === reason
    );
    if (id && isDocReason) {
      const newRows = this.rows.filter((entry: any) => {
        return entry.id !== id;
      });
      if (newRows.length !== this.rows.length) {
        this.setRows(newRows);
        return;
      }
    }
    this.loadData(this.accessUrl, true);
  }

  ngOnDestroy(): void {
    this.stateSub = unsub(this.stateSub);
    this.orderChangeSub = unsub(this.orderChangeSub);

    unsetOnClick(this.gridOptionsForOrders);
    unsetOnClick(this.gridOptionsForDocuments);
  }

  loadData(url: string, checkFilters: boolean) {
    const params: any = {};

    const f = this.filterValues;
    if (f) {
      f.text && setObjectValue(params, 'text', f.text);
      f.from && setObjectValue(params, 'from', toRequestDate(f.from));
      f.to && setObjectValue(params, 'to', toRequestDate(f.to));
    }

    //const isAdmin = this.stateService.isAdmin();

    this.dataService.get(url, params).subscribe((result: any) => {
      if (TrashGridType.ORDERS === this.orderGridType) {
        this.mapOrderResult(result);
      }
      if (TrashGridType.DOCUMENTS === this.orderGridType) {
        this.mapDocumentResult(result);
      }
    });
  }

  mapOrderResult(result: any) {
    const res = result?.result;

    if (!res) {
      return;
    }
    if (!res.success) {
      //TODO: Failed
      return;
    }
    const users = res.users;
    const rows = res.rows;
    const userMap: any = {};
    let uid: any;
    let userCount = 0;
    if (Array.isArray(users)) {
      users.forEach((entry: any) => {
        if (Array.isArray(entry) && entry.length > 2) {
          uid = entry[0];
          if (uid && !userMap[uid]) {
            userMap[uid] = entry;
            userCount++;
          }
        }
      });
      console.log('#Users>', userCount, users.length);
    }

    if (Array.isArray(rows)) {
      console.log('#orders:', rows.length);

      rows.forEach((item: any) => {
        let v: any;

        if (!item.status_name) {
          item.status_name = findOrderStatusNameById(item.status);
        }

        if (!item.team_name && item.tid && userMap[item.tid]) {
          v = userMap[item.tid];
          item.team_name = v[1] + ' ' + v[2];
        }

        if (!item.customer && item.cid && userMap[item.cid]) {
          v = userMap[item.cid];
          item.customer = {
            first_name: v[1],
            last_name: v[2],
            only_name: true
          };
        }
      });

      this.rows = rows;

      this.updateGrid();
    }
  }

  suppressRowTransform = false;

  mapDocumentResult(result: any) {
    const res = result?.result;

    if (!res) {
      return;
    }
    if (!res.success) {
      //TODO: Failed
      return;
    }
    const users = res.users;
    const rows = res.rows;
    const userMap: any = {};
    let uid: any;
    let userCount = 0;
    if (Array.isArray(users)) {
      users.forEach((entry: any) => {
        if (Array.isArray(entry) && entry.length > 2) {
          uid = entry[0];
          if (uid && !userMap[uid]) {
            userMap[uid] = entry;
            userCount++;
          }
        }
      });
      //console.log('#Users>', userCount, users.length);
    }


    if (Array.isArray(rows)) {
      const orderCounts: any = {};

      rows.forEach((item: any) => {
        let v: any;

        if (!item.status_name && item.status) {
          item.status_name = findOrderStatusNameById(item.status);
        }

        if (!item.team_name && item.tid && userMap[item.tid]) {
          v = userMap[item.tid];
          item.team_name = v[1] + ' ' + v[2];
        }

        if (!item.customer && item.cid && userMap[item.cid]) {
          v = userMap[item.cid];
          item.customer = {
            first_name: v[1],
            last_name: v[2],
            only_name: true
          };
        }

        if (item.missing) {
          item.error = 'Datei existiert nicht auf dem Server.';
        }
        const orderId = item.order_id;
        if (orderId) {
          orderCounts[orderId] = (orderCounts[orderId] || 0) + 1;
        }
      });

      console.log('COUNTS:', orderCounts);
      let hasRowSpan = false;

      for (let k in orderCounts) {
        if (orderCounts[k] > 1) {
          hasRowSpan = true;
          break;
        }
      }
      //console.log('Set?', hasRowSpan, this._grid);

      if (this._grid) {
        let gridOptions = this.gridOptionsForDocuments;

        if (hasRowSpan) {
          gridOptions = cloneDeep(this.gridOptionsForDocuments);

          let orderNrColumn: any = {
            field: 'order_id',
            headerName: 'Auftrag ID',
            width: 120,
            cellClass: GridColumnStyles.CELL_CLASS_INT,
            rowSpan: (function (counts: any) {
              return function (params: any) {
                var v = counts[params.data.order_id]
                //console.log('OID:', v, params.data.order_id);
                return v > 1 ? v : 1;
              };
            }(orderCounts))
          };

          gridOptions.suppressRowTransform = true;
          gridOptions.columnDefs[0] = orderNrColumn;
          this.suppressRowTransform = true;
        } else {
          this.suppressRowTransform = false;
        }
        this._grid.setGridOptions(gridOptions);
      }


      this.setRows(rows);
    }
  }

  setRows(rows: any[]) {
    this.rows = rows;
    setTimeout(() => {
      this.updateGrid();
    }, 200);
  }
}
